import api from 'lib/trpcClient';
import { keepPreviousData } from '@tanstack/react-query';
import { SortOrder } from 'further-types/utils';

type Params = {
  taxYearStart: string;
  firmId: string;
  page: number;
  rowsPerPage: number;
  order: SortOrder;
  orderBy: string;
  search?: string;
  isHardCopyOnly?: boolean;
};

export function useGetInvestorsForTaxYear(params: Params) {
  return api.annualTaxReport.getInvestorsForTaxYear.useQuery(
    {
      taxYearStart: Number(params.taxYearStart),
      firmId: params.firmId,
      page: params.page,
      rowsPerPage: params.rowsPerPage,
      order: params.order,
      orderBy: params.orderBy,
      ...(params.search && { search: params.search }),
      ...(params.isHardCopyOnly && { isHardCopyOnly: true }),
    },
    {
      enabled: !!params.taxYearStart && !!params.firmId,
      placeholderData: keepPreviousData,
    },
  );
}
